// Converte um File (ex: foto capturada pela câmera) em FileList, formato que o
// react-hook-form guarda para inputs type="file".
export const fileToFileList = (file: File): FileList => {
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  return dataTransfer.files;
};
